import Cookies from 'js-cookie';
import { createContext, useContext, useState } from 'react';

type CookiesContextType = {
  shouldShowCookies: boolean;
  setShouldShowCookies: React.Dispatch<React.SetStateAction<boolean>>;
};

const CookiesContext = createContext<CookiesContextType | undefined>(undefined);

export const CookiesProvider: React.FC<React.PropsWithChildren> = ({
  children
}) => {
  const [shouldShowCookies, setShouldShowCookies] = useState(
    Cookies.get('cookies_settings') !== 'true'
  );

  return (
    <CookiesContext.Provider
      value={{ shouldShowCookies, setShouldShowCookies }}
    >
      {children}
    </CookiesContext.Provider>
  );
};

export const useCookies = () => {
  const context = useContext(CookiesContext);
  if (context === undefined) {
    throw new Error('useCookies must be used within a CookiesProvider');
  }
  return context;
};
